module.exports = __webpack_public_path__ + "assets/img/zanLogo.8a798bb1.png";